
import './App.css';
import Home from './pages/home'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Routes,
} from "react-router-dom";
import GemDetail from './pages/gem-detail'
import History  from './pages/history'
import Market from './pages/market'
import About from './pages/aboutus'
import Contact from './pages/contact'
import TermandUse from './pages/term-use'
import Privacypolicy from './pages/privacy-policy'
import Anniversary from './pages/anniversary'
import Horoscope from './pages/horscope'
import Classfiction from './pages/classfiction'
import { Provider } from "react-redux";
import {Store} from "../src/state/store";
import Genuinity from './pages/genuinity ';
function App() {
  return (
    <Provider store={Store}>
    <div>
    <div className="App">
            <Router>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/gemdetail/:id" exact element={<GemDetail />} />
          <Route path="/history/:id" exact element={<History />} />
          <Route path="/market" exact element={<Market />} />
          <Route path="/about" exact element={<About />} />
          <Route path="/contact" exact element={<Contact />} />
          <Route path="/term" exact element={<TermandUse />} />
          <Route path="/privacy" exact element={<Privacypolicy/>}/>
          <Route path="/anniversary" exact element={<Anniversary/>} />
          <Route path="/horescope" exact element={<Horoscope />}/>
          <Route path="/classfication/:id" exact element={<Classfiction />}/>
          <Route path="/genuinity" exact element={<Genuinity />}/>
          
        </Routes>
      </Router>
</div>
    </div>
  </Provider>
  
  ) 
}

export default App;
